export default function Icon({ name, className, style }) {
  return <i className={(className || "") + " bi bi-" + name} style={style}></i>;
}